import MenuItem from "./menu-item";

function MegaMenu({ columns: oldColumns, cssClass }) {

  // Need to group items that have dark or inline
  const columns = oldColumns.map((column, index) => {
    let groupInline = [];
    let groupDark = [];
    return column.map((item, index) => {
      if (item.hasDark) {
        if (item.darkStart) {
          groupDark = [];
          groupDark.push(item);
        } else if (item.darkEnd) {
          groupDark.push(item);
          return {type: 'dark', groupDark}
        } else {
          groupDark.push(item);
        }
      } else if (item.hasInline) {
        if (item.inlineStart) {
          groupInline = [];
          groupInline.push(item);
        } else if (item.inlineEnd) {
          groupInline.push(item);
          return {type: 'inline', groupInline};
        } else {
          groupInline.push(item);
        }
      } else {
        return item;
      }
    }).filter(item => item !== undefined);   
  });

  const columnCount = columns.length;
  const columnClass = `w-full md:w-${
    columnCount === 1 ? 12 : Math.floor(12 / columnCount)
  }/12 px-2 `;

  return (
    <div
      className={`block visible hidden lg:block absolute w-full inset-x bg-white z-10 py-8 border-b-4 border-yellow-500 ${cssClass}`}
    >
      <div className="max-w-7xl mx-auto px-4">
        <ul className="flex flex-wrap -mx-2">
          {columns.map((column, index) => {
            return (
              <li key={`mega-menu-column:${index}`} className={columnClass}>
                <ul>
                  {column.map((item, index) => {
                    {if (item.type === 'dark') {
                        return <ul key={`group-dark:${index}`} className="my-2 bg-callout px-2 pt-1 pb-3 text-white shadow rounded">
                            {item.groupDark.map((darkItem, darkIndex) => {
                              return <li className={`${darkItem.icon ? '' : 'px-2 '}py-1`}>
                                  <MenuItem
                                    key={`menu-item-dark:${darkIndex}`}
                                    linkClass={`${darkItem.icon ? 'p-2' : ''}`}
                                    linkUrl={darkItem.url}
                                    linkText={darkItem.label}
                                    linkDescription={darkItem.description}
                                    linkIcon={darkItem.icon}
                                    linkImage={darkItem.image}
                                    linkSize={darkItem.size}
                                    linkDark={true}
                                  />
                                </li>
                            })}
                        </ul>
                      } else if (item.type === 'inline') {
                        return <ul key={`group-inline:${index}`}>
                            {item.groupInline.map((inlineItem, inlineIndex) => {
                              return <>
                                <li className="px-2 py-1 inline-block">
                                    <MenuItem
                                      key={`menu-item-inline:${inlineIndex}`}
                                      overrideClass=""
                                      linkUrl={inlineItem.url}
                                      linkText={inlineItem.label}
                                      linkDescription={inlineItem.description}
                                      linkIcon={inlineItem.icon}
                                      linkImage={inlineItem.image}
                                      linkSize={inlineItem.size}
                                      linkInline={true}
                                    />
                                </li>{inlineItem.inlineEnd ? '' : <li class="inline-block text-xs text-gray-300">|</li>}
                              </>
                            })}
                        </ul>
                    } else {
                        return <li key={`mega-menu-item:${index}`} className={`py-1`}>
                            <MenuItem
                              overrideClass={item.hasButton ? 'menu-item-button' : ''}
                              linkUrl={item.url}
                              linkText={item.label}
                              linkDescription={item.description}
                              linkIcon={item.icon}
                              linkImage={item.image}
                              linkSize={item.size}
                            />
                        </li>
                    }}

                    })}
                </ul>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default MegaMenu;
